<template>
  <div class="new-vehicle card">
    <div v-if="vehicle">
      <page-header
        :title="vehicle.vehiclename"
        :breadcrumbText="
          `Dashboard >> Settings  >> Vehicles >> ${vehicle.vehiclename}`
        "
      />
      <div class="my-4">
        <p class="font-semibold">
          <span>Inspection Status: </span
          ><span class="pl-2 text-red">Failed</span>
          <span class="pl-4 text-primary-blue font-semibold text-sm"
            >View RWC checklist</span
          >
        </p>
      </div>

      <hr class="hr" />

      <div class="vehicle-particulars">
        <div>
          <p class="text-secondary-orange font-semibold">Vehicle Particulars</p>
        </div>
        <div class="particulars-table">
          <table class="custom-table responsive-table">
            <thead>
              <tr>
                <th>Vehicle Particulars</th>
                <th>Document Number</th>
                <th>Image</th>
                <th>Expiry Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>License & Registration</td>
                <td>-----</td>
                <td>-----</td>
                <td>-----</td>
                <td class="update">Update Information</td>
              </tr>
              <tr>
                <td>Insurance cert.</td>
                <td>-----</td>
                <td>-----</td>
                <td>-----</td>
                <td class="update">Update Information</td>
              </tr>
              <tr>
                <td>RWC</td>
                <td>-----</td>
                <td>-----</td>
                <td>-----</td>
                <td class="update">Update Information</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <p class="text-primary-blue font-semibold cursor-pointer">
            Add Another Permit Document
          </p>
        </div>
      </div>

      <hr class="hr" />

      <div class="vehicle-identification">
        <div class="mb-4 d-flex">
          <p class="text-secondary-orange font-semibold pr-5">
            Vehicle Identification
          </p>
          <div
            class="cursor-pointer"
            @click="editVehicleIdentification = !editVehicleIdentification"
          >
            <edit-icon />
          </div>
        </div>

        <div class="container-fluid" v-if="editVehicleIdentification">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">VIN Number</label>
              <input type="text" class="input" v-model="vehicle.vinnumber" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Chasis Number</label>
              <input type="text" class="input" v-model="vehicle.chasisnumber" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Asset Tag</label>
              <input type="text" class="input" v-model="vehicle.assettag" />
            </div>
          </div>
          <div class="row">
            <div class="pl-0 my-5">
              <button
                class="button button-primary btn-sm"
                @click="updateVehicle('identification')"
              >
                <button-loader v-if="updatingVehicleIdentification" />
                <span v-else>Save Changes</span>
              </button>
              <button
                class="button button-secondary btn-sm"
                @click="editVehicleIdentification = false"
              >
                Discard
              </button>
            </div>
          </div>
        </div>

        <table class="responsive-table" v-else>
          <tr>
            <td class="font-semibold text-grey">
              Vehicle Identification Number:
            </td>
            <td>{{ vehicle.vinnumber }}</td>
          </tr>
          <tr>
            <td class="font-semibold text-grey">Chasis Number:</td>
            <td>{{ vehicle.chasisnumber }}</td>
          </tr>
          <tr>
            <td class="font-semibold text-grey">Asset Tag:</td>
            <td>{{ vehicle.assettag }}</td>
          </tr>
        </table>
      </div>

      <hr class="hr" />

      <div class="registered-to">
        <div class="mb-4 d-flex">
          <p class="text-secondary-orange font-semibold pr-5">
            Registered To
          </p>
          <div
            class="cursor-pointer"
            @click="editRegisteredTo = !editRegisteredTo"
          >
            <edit-icon />
          </div>
        </div>
        <div class="container-fluid" v-if="editRegisteredTo">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Terminals</label>
              <!-- <input type="text" class="input" v-model="newVehicle.terminals" /> -->
              <el-select v-model="vehicle.terminals" placeholder="Select">
                <el-option
                  v-for="terminal in terminals"
                  :key="terminal.id"
                  :label="terminal.name"
                  :value="terminal.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Routes</label>
              <!-- <input type="text" class="input" /> -->
              <el-select v-model="vehicle.routes" placeholder="Select">
                <el-option
                  v-for="route in routes"
                  :key="route.id"
                  :label="route.routeName"
                  :value="route.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="pl-0 my-5">
              <button
                class="button button-primary btn-sm"
                @click="updateVehicle('registeredTo')"
              >
                <button-loader v-if="updatingRegisteredTo" />
                <span v-else>Save Changes</span>
              </button>
              <button
                class="button button-secondary btn-sm"
                @click="editRegisteredTo = false"
              >
                Discard
              </button>
            </div>
          </div>
        </div>
        <!-- <table v-else class="responsive-table">
          <tr>
            <td class="font-semibold text-grey">
              Terminals:
            </td>
            <td>{{ vehicle.terminate.name }}</td>
          </tr>
          <tr>
            <td class="font-semibold text-grey">Routes:</td>
            <td>{{ vehicle.routevehicle.name }}</td>
          </tr>
        </table> -->
      </div>

      <hr class="hr" />

      <div class="vehicle-capacity">
        <div class="mb-4 d-flex">
          <p class="text-secondary-orange font-semibold pr-5">
            Vehicle Capacity
          </p>
          {{ editVehicleCapacity }}
          <div
            class="cursor-pointer"
            @click="editVehicleCapacity = !editVehicleCapacity"
          >
            <edit-icon />
          </div>
        </div>
        <div class="container-fluid" v-if="editVehicleCapacity">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Vehicle Type</label>
              <input type="text" class="input" v-model="vehicle.vehicletype" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Max. Capacity (Tonnage)</label>
              <input type="text" class="input" v-model="vehicle.carriageCapacity" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Loading Capacity (Tonnage)</label>
              <input
                type="text"
                class="input"
                v-model="vehicle.currentLoadCapacity"
              />
            </div>
          </div>
          <div class="row">
            <div class="pl-0 my-5">
              <button
                class="button button-primary btn-sm"
                @click="updateVehicle('capacity')"
              >
                <button-loader v-if="updatingVehicleCapacity" />
                <span v-else>Save Changes</span>
              </button>
              <button
                class="button button-secondary btn-sm"
                @click="editVehicleCapacity = false"
              >
                Discard
              </button>
            </div>
          </div>
        </div>
        <table v-else class="responsive-table">
          <tr>
            <td class="font-semibold text-grey">
              Vehicle Type:
            </td>
            <td>{{ vehicle.vehicletype }}</td>
          </tr>
          <tr>
            <td class="font-semibold text-grey">Max. Capacity Tonnage:</td>
            <td>{{ vehicle.carriageCapacity }}</td>
          </tr>
          <tr>
            <td class="font-semibold text-grey">Loading Capacity Tonnage:</td>
            <td>{{ vehicle.currentLoadCapacity }}</td>
          </tr>
        </table>
      </div>
      <!-- <div class="button-wrapper">
      <button class="button-secondary button-long button">Cancel</button>
      <button class="button-primary button-long button">Save</button>
    </div> -->
    </div>
    <div class="my-5" v-else>
      <loader />
    </div>
  </div>
</template>

<script>
import EditIcon from "../partials/EditIcon";
export default {
  components: {
    EditIcon,
  },
  data() {
    return {
      vehicleId: null,
      vehicle: null,
      editVehicleIdentification: false,
      updatingVehicle: false,
      editRegisteredTo: false,
      routes: [],
      terminals: [],
      editVehicleCapacity: false,
      updatingVehicleIdentification: false,
      updatingVehicleCapacity: false,
      updatingRegisteredTo: false,
    };
  },
  mounted() {
    this.vehicleId = localStorage.getItem("vehicleId");
    if (this.vehicleId) {
      this.getVehicleDetails();
    } else {
      this.$router.push({ name: "Vehicles" });
    }
    // this.getAllTerminals();
    this.getAllRoutes();
  },
  methods: {
    async getVehicleDetails() {
      try {
        let response = await this.$_getSingleVehicle(this.vehicleId);
        console.log(response);
        this.vehicle = response.data.data.fleet;
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateVehicle(updateType) {
      this.updatingVehicle = true;
      if (updateType == "capacity") {
        this.updatingVehicleCapacity = true;
      } else if (updateType == "registeredTo") {
        this.updatingRegisteredTo = true;
      } else {
        this.updatingVehicleIdentification = true;
      }
      try {
        let response = await this.$_updateVehicle(this.vehicle);
        console.log(response);
        this.generateToast("Vehicle Updated", "success");
        this.$router.push({ name: "Vehicles" });
        this.resetAllEditFields();
      } catch (error) {
        this.handleError(error);
        this.updatingVehicle = false;
      }
    },
    async getAllRoutes() {
      try {
        let response = await this.$_getAllRoutes();
        console.log(response);
        this.routes = response.data.findRoute;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllTerminals() {
      try {
        let response = await this.$_getAllTerminals();
        console.log(response);
        // this.terminals = response.data.findRoute[0].terminal;
        this.createTerminalsArray(response.data.findRoute);
      } catch (error) {
        this.handleError(error);
      }
    },
    createTerminalsArray(terminals) {
      terminals.forEach((terminal) => {
        this.terminals.push(terminal.terminal[0]);
      });
      this.terminals = this.terminals.filter(Boolean);
    },
    resetAllEditFields() {
      this.editVehicleIdentification = false;
      this.editVehicleIdentification = false;
      this.editVehicleCapacity = false;
      (this.updatingVehicleIdentification = false),
        (this.updatingVehicleCapacity = false),
        (this.updatingRegisteredTo = false);
    },
  },
};
</script>

<style scoped>
.update {
  color: #f57a4d;
  font-weight: bold;
  cursor: pointer;
}
.vehicle-identification td,
.registered-to td,
.vehicle-capacity td {
  padding-left: 0;
}
.button {
  width: 8rem;
  margin-right: 1rem;
}
</style>
